import * as helper from "../helpers/WebServicesHelper";
import * as AppConfig from "../../logic/GlobalAppConfig";

const defaultTimeoutInMS = 20000;
const anyChangesTimeoutInMS = 10000;

export async function fetchGetAvailableSolutions(token, sessionId) {
  let baseUrl = AppConfig.getBosWebGuiServiceUrl();
  return await fetch(baseUrl + "/GetAvailableSolutions", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeadersWithAuthenticationAndSession(token, sessionId)
  })
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(helper.checkDefaultErrorMessage)
    .then(json => {
      //console.log("GetAvailableSolutions: " + JSON.stringify(json));
      return json.solutions;
    });
}

export async function fetchGetMainTasks(token, sessionId, dataSegmentId) {
  let baseUrl = AppConfig.getBosWebGuiServiceUrl();
  return await fetch(baseUrl + "/GetMainTasks", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeadersWithAuthenticationAndSession(token, sessionId),
    body: JSON.stringify({
      GlobalDatasegmentId: dataSegmentId
    })
  })
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(helper.checkDefaultErrorMessage)
    .then(json => {
      //console.log("GetMainTasks: " + JSON.stringify(json));
      return json.mainTasks;
    });
}

export async function fetchGetUserTasks(token, sessionId, dataSegmentId) {
  let baseUrl = AppConfig.getBosWebGuiServiceUrl();
  return await fetch(baseUrl + "/GetUserTasks", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeadersWithAuthenticationAndSession(token, sessionId),
    body: JSON.stringify({
      GlobalDatasegmentId: dataSegmentId
    })
  })
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(helper.checkDefaultErrorMessage)
    .then(json => {
      //console.log("GetUserTasks: " + JSON.stringify(json));
      return json.userTasks;
    });
}

export async function fetchProcessUrl(token, sessionId, uri) {
  let baseUrl = AppConfig.getBosWebGuiServiceUrl();
  //workaround for current limitation of url routing
  let encodedUri = helper.encodeBosUri(uri);
  return await fetch(baseUrl + "/ProcessUrl", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeadersWithAuthenticationAndSession(token, sessionId),
    body: JSON.stringify({
      NavigationUri: encodedUri
    })
  })
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(helper.checkDefaultErrorMessage)
    .then(json => {
      //console.log("ProcessUrl: " + JSON.stringify(json));
      return json;
    });
}

export async function fetchStartSession(token) {
  let baseUrl = AppConfig.getBosWebGuiServiceUrl();
  return await fetch(baseUrl + "/StartSession", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: token ? helper.getDefaultJsonHeadersWithAuthentication(token) : helper.getDefaultJsonHeaders()
  })
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(helper.checkDefaultErrorMessage)
    .then(result => {
      //console.log("StartSession: " + result);
      return result;
    });
}

export async function fetchLeaveSession(token, sessionId) {
  let baseUrl = AppConfig.getBosWebGuiServiceUrl();
  return await fetch(baseUrl + "/LeaveSession", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: token ? helper.getDefaultJsonHeadersWithAuthenticationAndSession(token, sessionId) : helper.getDefaultJsonHeadersWithSession(sessionId)
  })
    .then(helper.checkStatus);
}

export async function fetchCloseSession(token, sessionId) {
  let baseUrl = AppConfig.getBosWebGuiServiceUrl();
  return await fetch(baseUrl + "/CloseSession", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeadersWithAuthenticationAndSession(token, sessionId)
  })
    .then(helper.checkStatus);
}

export async function fetchGetViewports(token, sessionId, availableWidth, availableHeight) {
  let baseUrl = AppConfig.getBosWebGuiServiceUrl();
  return await fetch(baseUrl + "/GetViewports", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeadersWithAuthenticationAndSession(token, sessionId),
    body: JSON.stringify({
      AvailableWidth: availableWidth,
      AvailableHeight: availableHeight
    })
  })
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(helper.checkDefaultErrorMessage)
    .then(json => {
      //console.log("GetViewport: " + JSON.stringify(json));
      return json;
    });
}

export async function fetchAnyChanges(token, sessionId, keepAliveSessions = []) {
  let baseUrl = AppConfig.getBosWebGuiServiceUrl();
  return await fetch(baseUrl + "/AnyChanges", {
    signal: helper.timeoutSignal(anyChangesTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeadersWithAuthenticationAndSession(token, sessionId),
    body: JSON.stringify({
      KeepAliveSessions: keepAliveSessions
    })
  })
    .catch(helper.setBosServerUnavailableAndRethrow)
    .then(helper.setBosServerAvailable)
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(json => helper.checkDefaultErrorMessage(json, false))
    .then(json => {
      //console.log("AnyChanges: " + JSON.stringify(json));
      return json;
    });
}

export async function fetchStartWork(token, sessionId, viewportRef, widgetRef) {
  let baseUrl = AppConfig.getBosWebGuiServiceUrl();
  return await fetch(baseUrl + "/StartWork", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeadersWithAuthenticationAndSession(token, sessionId),
    body: JSON.stringify({
      ViewportRef: viewportRef,
      WidgetRef: widgetRef
    })
  })
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(helper.checkDefaultErrorMessage)
    .then(json => {
      //console.log("StartWork: " + JSON.stringify(json));
      return json;
    });
}

export async function fetchWriteBack(token, sessionId, viewportRef, widgetRef, content) {
  let baseUrl = AppConfig.getBosWebGuiServiceUrl();
  return await fetch(baseUrl + "/WriteBack", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeadersWithAuthenticationAndSession(token, sessionId),
    body: JSON.stringify({
      ViewportRef: viewportRef,
      WidgetRef: widgetRef,
      Content: content
    })
  })
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(helper.checkDefaultErrorMessage)
    .then(json => {
      //console.log("WriteBack: " + JSON.stringify(json));
      return json;
    });
}

export async function fetchGetContextActions(token, sessionId, viewportRef, widgetRef) {
  let baseUrl = AppConfig.getBosWebGuiServiceUrl();
  return await fetch(baseUrl + "/GetContextActions", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeadersWithAuthenticationAndSession(token, sessionId),
    body: JSON.stringify({
      ViewportRef: viewportRef,
      WidgetRef: widgetRef
    })
  })
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(helper.checkDefaultErrorMessage)
    .then(json => {
      console.log("GetContextActions: " + JSON.stringify(json));
      return json;
    });
}

export async function fetchDoAction(token, sessionId, viewportRef, widgetRef, actionRef, content) {
  let baseUrl = AppConfig.getBosWebGuiServiceUrl();
  return await fetch(baseUrl + "/DoAction", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeadersWithAuthenticationAndSession(token, sessionId),
    body: JSON.stringify({
      ViewportRef: viewportRef,
      WidgetRef: widgetRef,
      ActionRef: actionRef,
      Content: content,
    })
  })
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(helper.checkDefaultErrorMessage)
    .then(json => {
      //console.log("doAction: " + JSON.stringify(json));
      return json;
    });
}

export async function fetchGetSettings(token, sessionId) {
  let baseUrl = AppConfig.getBosWebGuiServiceUrl();
  return await fetch(baseUrl + "/GetSettings", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeadersWithAuthenticationAndSession(token, sessionId)
  })
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(helper.checkDefaultErrorMessage)
    .then(json => {
      //console.log("GetSettings: " + JSON.stringify(json));
      return json;
    });
}

export async function fetchSetSettings(token, sessionId, typeface, fontSize, defaultRowHeight, defaultWidgetDistance, labelControlDistance, floatingLabelFactor, navigationControlWidth, viewportHeight, viewportWidth) {
  let baseUrl = AppConfig.getBosWebGuiServiceUrl();
  return await fetch(baseUrl + "/SetSettings", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeadersWithAuthenticationAndSession(token, sessionId),
    body: JSON.stringify({
      Typeface: typeface,
      FontSize: fontSize,
      DefaultRowHeight: defaultRowHeight,
      DefaultWidgetDistance: defaultWidgetDistance,
      LabelControlDistance: labelControlDistance,
      FloatingLabelFactor: floatingLabelFactor,
      NavigationControlWidth: navigationControlWidth,
      ViewportHeight: viewportHeight,
      ViewportWidth: viewportWidth,
    })
  })
    .then(helper.checkStatus)
    .then(res => res.text())
    .then(helper.checkDefaultErrorMessage)
    .then(result => {
      //console.log("SetSettings: " + result);
      return result;
    });
}

export async function fetchGetAutocompleteSuggestions(token, sessionId, autocompleteId, prefix, maxResults) {
  let baseUrl = AppConfig.getBosWebGuiServiceUrl();
  return await fetch(baseUrl + "/GetAutocompleteSuggestions", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeadersWithAuthenticationAndSession(token, sessionId),
    body: JSON.stringify({
      AutocompleteId: autocompleteId,
      Prefix: prefix,
      MaxResults: maxResults,
    })
  })
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(helper.checkDefaultErrorMessage)
    .then(json => {
      //console.log("GetAutocompleteSuggestions: " + JSON.stringify(json));
      return json;
    });
}

export async function fetchGetAvailableLanguages(token, sessionId, dataSegmentId) {
  let baseUrl = AppConfig.getBosWebGuiServiceUrl();
  return await fetch(baseUrl + "/GetAvailableLanguages", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeadersWithAuthenticationAndSession(token, sessionId),
    body: JSON.stringify({
      GlobalDatasegmentId: dataSegmentId
    })
  })
    .then(helper.checkStatus)
    .then(res => res.json())
    .then(helper.checkDefaultErrorMessage)
    .then(json => {
      //console.log("GetAvailableLanguages: " + JSON.stringify(json));
      return json;
    });
}

export async function fetchSetLanguagePreferences(token, sessionId, dataSegmentId, uiLanguageISOCode, dataViewLanguageISOCode) {
  let baseUrl = AppConfig.getBosWebGuiServiceUrl();
  return await fetch(baseUrl + "/SetLanguagePreferences", {
    signal: helper.timeoutSignal(defaultTimeoutInMS),
    method: helper.POST_METHOD,
    headers: helper.getDefaultJsonHeadersWithAuthenticationAndSession(token, sessionId),
    body: JSON.stringify({
      GlobalDatasegmentId: dataSegmentId,
      UILanguageISOCode: uiLanguageISOCode,
      DataViewLanguageISOCode: dataViewLanguageISOCode
    })
  })
    .then(helper.checkStatus)
    .then(helper.checkDefaultErrorMessage)
    .then(result => {
      //console.log("SetLanguagePreferences: " + JSON.stringify(json));
      return result;
    });
}